import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ISSUE_TEMPLATE_ORDER_TEMPLATE_MAPS = `${TASK_SERVICE}/issue-template-order-template-maps`;

export const issueTemplateOrderTemplateMaps = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_ISSUE_TEMPLATE_ORDER_TEMPLATE_MAPS,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  /**
   * Creates a new issue template order template map.
   *
   * @param {Object} params - The parameters for the request.
   * @param {Object} params.data - The data for the new issue template order template map.
   * @param {string} params.data.orderTemplateId- The GUID of the order template.
   * @param {string} params.data.issueTemplateId - The GUID of the issue template.
   * @param {Object} [params.toastMessageConfig] - Optional configuration for toast messages.
   * @returns {Promise<Object>} The response from the API.
   */
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_ISSUE_TEMPLATE_ORDER_TEMPLATE_MAPS,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  /**
   * Deletes an issue template order template map.
   *
   * @param {Object} params - The parameters for the request.
   * @param {string} params.orderTemplateId- The GUID of the order template.
   * @param {string} params.issueTemplateId - The GUID of the issue template.
   * @param {string} params.modifiedOn - The date when the issue template order template map was last modified.
   * @param {Object} [params.toastMessageConfig] - Optional configuration for toast messages.
   * @returns {Promise<Object>} The response from the API.
   */
  delete: async ({
    orderTemplateId,
    issueTemplateId,
    modifiedOn,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ISSUE_TEMPLATE_ORDER_TEMPLATE_MAPS}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      params: { orderTemplateId, issueTemplateId },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
